import { NavLink, Outlet } from "react-router-dom";
import { BarChart3, Bot, LayoutDashboard, MessageCircle, Receipt, Settings } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

const navItems = [
  { to: "/dashboard", labelKey: "common:nav.dashboard", icon: LayoutDashboard },
  { to: "/bots", labelKey: "common:nav.bots", icon: Bot },
  { to: "/analytics", labelKey: "common:nav.analytics", icon: BarChart3 },
  { to: "/billing", labelKey: "common:nav.billing", icon: Receipt },
  { to: "/settings", labelKey: "common:nav.settings", icon: Settings },
] as const;

export function AppLayout() {
  const { t } = useTranslation("common");
  return (
    <div className="flex h-screen w-full bg-slate-50">
      <Sidebar>
        <nav className="flex flex-col gap-1 p-4">
          {navItems.map(({ to, labelKey, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition ${
                  isActive
                    ? "bg-brand-50 text-brand-700"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {t(labelKey)}
            </NavLink>
          ))}
        </nav>
      </Sidebar>

      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export { MessageCircle };
